

export default function BeneficiariesList({children, ...props}) {
    
    
    return (
        <div className="mt-[25px]">
            <div className="w-full">
                <div className="flex flex-wrap gap-[25px]">
                    {children}
                </div>
            </div>
        </div>
    )
}